// Evidence and dating conventions are documented in /project-dates.md.
// “By” is a latest-known date from the original site, not a launch claim.
export const projectDates = {
  '/portfolio/glorb': '2022–2026',
  'https://dickstendo.com': 'Documented 2026',
  '/projects/nftclub': 'By 2021',
  '/projects/artistbuyingownnft': 'By 2021',
  '/projects/photoboo': '2019',
  '/projects/photoboo/gallery': 'October 2019',
  '/projects/antenna': '2019',
  '/projects/fishfinder': '2019',
  '/projects/stylegan': 'By 2019',
  '/projects/stylegan/propaganda': 'By 2019',
  '/projects/stylegan/me': 'By 2019',
  '/projects/stylegan/tattoos': 'By 2019',
  '/projects/stylegan/phil': 'By 2019',
  '/projects/replaced': 'By 2019',
  '/a/2019-12-31': 'December 2019',
  '/galleries/2019-12-31': 'December 31, 2019',
  '/projects/photoboothOfFriendship': 'By 2020',
  'https://web.archive.org/web/20160309032223/http://cryptographi.com/': '2013',
  'http://www.galactictick.com': '2016',
  'https://www.devnews.dev': 'By 2019',
  'https://litprotocol.com': 'By 2021'
}
